import { useMemo } from 'react';

import { centsToDollar, convertToInitials } from 'core/Utils';
import { Avatar, Flex, Text } from 'ui';

import { useShowCurrentCampaign } from '../../../../api/new/campaigns/get';
import { CampaignDonation } from '../../../../api/new/donations/get';

type Props = {
  donation: CampaignDonation;
};

export const CampaignDonorCard = ({ donation }: Props) => {
  const { data: campaign } = useShowCurrentCampaign();

  const verb = useMemo(
    () => (donation?.status == 'pledged' ? 'pledged' : 'donated'),
    [donation?.status]
  );
  const perUnit = useMemo(
    () =>
      donation?.status == 'pledged' && campaign?.__type == 'athon' ? (
        <Text span c={'gray'}>
          / {campaign?.units_of_activity_singular}
        </Text>
      ) : null,
    [donation?.status]
  );

  if (donation && donation?.subtotal < 0) return null;

  return (
    <Flex align={'center'} justify={'space-between'}>
      <Flex align={'center'} gap={'sm'}>
        <Avatar size={'sm'} radius={'xl'} color="cobalt.5">
          {convertToInitials(donation?.first_name)}
        </Avatar>
        <Text fz="sm">
          {`${donation?.first_name} ${verb} ${centsToDollar(donation?.subtotal)}`} {perUnit}
        </Text>
      </Flex>
      <Text fz="xs" fw={600}>
        {donation?.ago}
      </Text>
    </Flex>
  );
};
